/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const BoxDev16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M10.547 2c.2 0 .391.08.53.221l4.706 4.738.078.095c.21.3.183.717-.083.993l-4.699 4.73-.09.078a.745.745 0 01-.973-.076L5.371 8.044l-.082-.096a.762.762 0 01.078-.988l.767-.766.066-.08a.584.584 0 00-.06-.738.567.567 0 00-.809-.006l-.766.766-.125.137a1.93 1.93 0 00.124 2.59l2.629 2.68-1.231 1.233-.091.078a.761.761 0 01-.983-.076L.22 8.043l-.08-.096a.783.783 0 01.083-.993l4.666-4.733.09-.077a.76.76 0 01.981.078l4.668 4.735.082.096a.757.757 0 01-.078.986l-.77.766-.067.08a.582.582 0 00.059.738c.22.229.583.232.808.008l.77-.766.126-.138a1.926 1.926 0 00-.126-2.592L8.79 3.455l1.224-1.232.09-.078A.748.748 0 0110.547 2z"
        />
    </AccessibleSVG>
);

export default BoxDev16;
